import React, { ReactNode } from "react";
import "./LevelInputBlocks.scss";
import { useTranslation } from "react-i18next";

interface IProps {
    children: ReactNode | ReactNode[];
}

export function LevelInputBlocks({ children }: IProps) {
    const { t } = useTranslation();
    return (
        <div className="level-input-blocks-wrapper">
            {children}
            <div className="level-input-blocks-background">
                <svg xmlns="http://www.w3.org/2000/svg" width="841" height="469.734" viewBox="0 0 841 469.734">
                    <defs>
                        <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                            <stop offset="0" stopColor="#29abe2" stopOpacity="0.302"/>
                            <stop offset="1" stopColor="#226a8f"/>
                        </linearGradient>
                    </defs>
                    <path id="Path_82" data-name="Path 82" d="M940,420.245H400l-8.91,20.193H208.91L200,420.245H140a20,20,0,0,0-20,20V857.171a20,20,0,0,0,20,20H940a20,20,0,0,0,20-20V440.245A20,20,0,0,0,940,420.245Z" transform="translate(-119.5 -407.937)" stroke="#33dee2" strokeMiterlimit="10" strokeWidth="1" fill="url(#linear-gradient)"/>
                    <text id="OUTPUT" transform="translate(154.5 18)" fill="#fff" fontSize="18" fontFamily="FranklinGothicATF-Regular, Franklin Gothic ATF" letterSpacing="0.05em"><tspan x="0" y="0">{ t('game.output').toUpperCase() }</tspan></text>
                </svg>
            </div>
        </div>
    )
}
